import { useNavigate } from "react-router-dom";

export const AuthAction = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const mode = queryParams.get("mode");
  const oobCode = queryParams.get("oobCode");

  if (mode === "resetPassword") {
    navigate(`/auth/reset-password?oobCode=${oobCode}`);
  }

  return <></>;
};
